var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "marginForm",
              attrs: {
                model: _vm.marginForm,
                "label-width": "80px",
                size: "mini",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("marginModel"),
                      expression: "showProperty('marginModel')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.margin_model") },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "mini" },
                      on: {
                        change: function ($event) {
                          return _vm.changeMarginStyle(
                            _vm.marginForm.marginModel,
                            "marginModel"
                          )
                        },
                      },
                      model: {
                        value: _vm.marginForm.marginModel,
                        callback: function ($$v) {
                          _vm.$set(_vm.marginForm, "marginModel", $$v)
                        },
                        expression: "marginForm.marginModel",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "auto" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.margin_model_auto"))),
                      ]),
                      _c("el-radio-button", { attrs: { label: "absolute" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.margin_model_absolute"))),
                      ]),
                      _c("el-radio-button", { attrs: { label: "relative" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.margin_model_relative"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.showProperty("marginModel") &&
                        _vm.marginForm.marginModel !== "auto",
                      expression:
                        "showProperty('marginModel') && marginForm.marginModel !== 'auto'",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("marginTop"),
                          expression: "showProperty('marginTop')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: {
                        label: _vm.$t("chart.text_pos_top"),
                        prop: "marginTop",
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "hide-icon-number",
                          attrs: {
                            placeholder: _vm.placeholder,
                            type: "number",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeMarginStyle(
                                _vm.marginForm.marginTop,
                                "marginTop"
                              )
                            },
                          },
                          model: {
                            value: _vm.marginForm.marginTop,
                            callback: function ($$v) {
                              _vm.$set(_vm.marginForm, "marginTop", $$v)
                            },
                            expression: "marginForm.marginTop",
                          },
                        },
                        [
                          _vm.unitSuffix
                            ? _c("template", { slot: "append" }, [
                                _vm._v(_vm._s(_vm.unitSuffix)),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("marginBottom"),
                          expression: "showProperty('marginBottom')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: {
                        label: _vm.$t("chart.text_pos_bottom"),
                        prop: "marginBottom",
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "hide-icon-number",
                          attrs: {
                            placeholder: _vm.placeholder,
                            type: "number",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeMarginStyle(
                                _vm.marginForm.marginBottom,
                                "marginBottom"
                              )
                            },
                          },
                          model: {
                            value: _vm.marginForm.marginBottom,
                            callback: function ($$v) {
                              _vm.$set(_vm.marginForm, "marginBottom", $$v)
                            },
                            expression: "marginForm.marginBottom",
                          },
                        },
                        [
                          _vm.unitSuffix
                            ? _c("template", { slot: "append" }, [
                                _vm._v(_vm._s(_vm.unitSuffix)),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("marginLeft"),
                          expression: "showProperty('marginLeft')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: {
                        label: _vm.$t("chart.text_pos_left"),
                        prop: "marginLeft",
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "hide-icon-number",
                          attrs: {
                            placeholder: _vm.placeholder,
                            type: "number",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeMarginStyle(
                                _vm.marginForm.marginLeft,
                                "marginLeft"
                              )
                            },
                          },
                          model: {
                            value: _vm.marginForm.marginLeft,
                            callback: function ($$v) {
                              _vm.$set(_vm.marginForm, "marginLeft", $$v)
                            },
                            expression: "marginForm.marginLeft",
                          },
                        },
                        [
                          _vm.unitSuffix
                            ? _c("template", { slot: "append" }, [
                                _vm._v(_vm._s(_vm.unitSuffix)),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("marginRight"),
                          expression: "showProperty('marginRight')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: {
                        label: _vm.$t("chart.text_pos_right"),
                        prop: "marginRight",
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "hide-icon-number",
                          attrs: {
                            placeholder: _vm.placeholder,
                            type: "number",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeMarginStyle(
                                _vm.marginForm.marginRight,
                                "marginRight"
                              )
                            },
                          },
                          model: {
                            value: _vm.marginForm.marginRight,
                            callback: function ($$v) {
                              _vm.$set(_vm.marginForm, "marginRight", $$v)
                            },
                            expression: "marginForm.marginRight",
                          },
                        },
                        [
                          _vm.unitSuffix
                            ? _c("template", { slot: "append" }, [
                                _vm._v(_vm._s(_vm.unitSuffix)),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }